import * as React from "react";
import { Box, Button, Grid2, Typography, TextField, useMediaQuery, IconButton, Snackbar, Alert,Modal} from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import StepperCard from "../StepperCard";
import { CustomStepConnector, StepIcon, useSteps  } from "../StepperComponents"; // Import steps
import { useSelector, useDispatch } from 'react-redux';
import { checkAndNavigate, setActiveStep } from "../../../Redux/usersSlice";
import navLogo from "../../../Assets/Images/logo.svg"
import DigilockerStyles from "./Digilocker.module.css"
// import panImg from "../../../Assets/Images/panImg.png"
import icon from "../../../Assets/Images/icon.svg"
import verified from "../../../Assets/Images/verifysuccess.svg"
import digilogo from "../../../Assets/Images/digiLocker.png"
import { digilocker, setDigiandmanualStatus, setDigiAadharStatus, setDigiStatus, setDigiDataPanStatus, setDigiDataAadhaarStatus, setDigiPanStatus, setAadharandPanStatus, ocrCheck, manualUploadDigilocker, absentUploadDigilocker, panUploadDigilocker, aadhaarUploadDigilocker, setAadharStatusTofalse, setPanStatusTofalse, setDigiReload, setDigiStepStatus, setBothStatusTofalse, setDigiDataBothStatus, setDigiManualUploadStatus, setDigiManualUploadStatusToFalse, setDigiDataTONull, setUploadTypeToManual, setUploadTypeToAbsent, setBackButton, setFaceMatchToTrue, setDisplay, setDigiButtonClicked, setPanOcrToTrue, setAadhaarOcrToTrue, setDigiError, setGuardian, setDigilockerCompleted, setDigiData } from "../../../Redux/usersSlice";
import { kycVerified } from "../../../Redux/usersSlice";
import { useSearchParams } from "react-router-dom";
// import { useTheme } from '@mui/material/styles';
import * as CryptoJS from "crypto-js"
import { FileUploader } from "react-drag-drop-files";
import lock from "../../../Assets/Images/lock.svg"
import * as pdfjsLib from "pdfjs-dist";
import { ArrowBack } from "@mui/icons-material";
import { Cropper } from 'react-advanced-cropper'
import 'react-advanced-cropper/dist/style.css'
import { ImageRestriction } from 'react-advanced-cropper';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import NumOtpStyles from "../SignUpPhone/SignUpPhOtp.module.css"
import collab from '../../../Assets/Images/collab1.svg';
import errorIcon from "../../../Assets/Images/bell.gif"
pdfjsLib.GlobalWorkerOptions.workerSrc =
    "https://unpkg.com/pdfjs-dist@2.10.377/build/pdf.worker.min.js";



export default function Digilocker() {
      const steps = useSteps();
    const navigate = useNavigate();
    const location = useLocation();

    const dispatch = useDispatch();

    const { activeStep, userData, loading, digiStatus, manualStatus, aadharStatus, panStatus, digilockerData, digiReloadStatus, digiManualUplaod, uploadType, digiBackButton, digiError, digiDisp, digiButClicked, panOcr, aadhaarOcr, backToDigi,digilockerCompleted,source } = useSelector(state => state.user);

    
    // const theme = useTheme();
   const isMobile = useMediaQuery('(max-width:1000px)');

    const backendResponse = userData.steps
    const email = userData?.email.toLowerCase();
    const mobile = userData?.mobile;
    let digilockerStatus = backendResponse["DigiLocker KYC verified Docs"].status
    const [fileName, setFileName] = React.useState("");





    const [searchParams] = useSearchParams();
    const [status, setStatus] = React.useState(null);
    const [aadharFrontError, setAadharFrontError] = React.useState("")
    const [aadharBackError, setAadharBackError] = React.useState("")
    const [panError, setPanError] = React.useState("")
    const [enable, setEnable] = React.useState(false)
    const [aadharData, setAadharData] = React.useState("")
    const [aadharFrontData, setAadharFrontData] = React.useState("")
    const [aadharBackData, setAadharBackData] = React.useState("")
    const [panData, setPanData] = React.useState("")
    const [panFileName, setPanFileName] = React.useState("")
    const [aadharFrontFileName, setAadharFrontFileName] = React.useState("")
    const [aadharBackFileName, setAadharBackFileName] = React.useState("")
    
    // const [aadharStatus, setAadharStatus] = React.useState(false);
    // const [panStatus, setPanStatus] = React.useState(false);
    // const [digiStatus,setDigiStatus]=React.useState(true)
    // const [manualStatus,setManualStatus]=React.useState(false)



    const [aadhaarFrontFiletype, setAadhaarFrontFiletype] = React.useState("")
    const [aadhaarBackFiletype, setAadhaarBackFiletype] = React.useState("")
    const [panFiletype, setPanFiletype] = React.useState("")
    const [aadharUpload, setAadharUpload] = React.useState("")
    const [panUpload, setPanUpload] = React.useState("")
    const [aadhaarEnable, setAadhaarEnable] = React.useState(false)
    const [panEnable, setPanEnable] = React.useState(false)
    const [aadhaarFrontVerify, setAadhaarFrontVerify] = React.useState(false)
    const [aadhaarBackVerify, setAadhaarBackVerify] = React.useState(false)
    const [panVerify, setPanVerify] = React.useState(false)
    const [aadhaarFileUploader, setAadhaarFileUploader] = React.useState(true)
    const [panFileUploader, setPanFileUploader] = React.useState(true)
    const [ocrValidated, setOcrValidated] = React.useState(false);
    const [panOcrValidated, setPanOcrValidated] = React.useState(false);
    const [panFail,setPanFail]=React.useState("")
    // const [digiError,setDigiError]=React.useState("")
    const [refresh, setRefresh] = React.useState(0);
    const [crop, setCrop] = React.useState({
        modal: false,
        image: '',
        fileType: ''
    })
    const cropperRef = React.useRef(null)


   

    React.useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible" && digilockerCompleted) {
                setRefresh((prev) => prev + 1);
            }
        };

        const handlePageShow = () => {
            if (digilockerCompleted) {
                setRefresh((prev) => prev + 1);
            }
        };

        window.addEventListener("pageshow", handlePageShow);
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            window.removeEventListener("pageshow", handlePageShow);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [digilockerCompleted]);




    const defaultSize = ({ imageSize, visibleArea }) => {
        return {
            width: (visibleArea || imageSize).width,
            height: (visibleArea || imageSize).height,
        };
    }


    const rotateRight = () => {
        if (cropperRef.current) {
            cropperRef.current.rotateImage(90, { relative: true });
        }
    };

    const rotateLeft = () => {
        if (cropperRef.current) {
            cropperRef.current.rotateImage(-90, { relative: true });
        }
    };


    // Snackbar state
        const [snackbar, setSnackbar] = React.useState({
          open: false,
          message: "",
          severity: "info", // 'error', 'warning', 'info', 'success'
        });
    
        const showMessage = (message, severity = "info") => {
          setSnackbar({ open: true, message, severity });
        };
      
        const handleCloseSnackbar = () => {
          setSnackbar(prev => ({ ...prev, open: false }));
        };

    React.useEffect(() => {
        console.log("parmas", searchParams)
        if (!searchParams.get("data")){
            console.log("params in")
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "kyc_step_viewed",
                step_name: "digilocker_page_viewed",
                page_path: window.location.pathname
            });
        }
    }, []);


    // React.useEffect(() => {
    //     console.log("useEffect 2")
    //     // dispatch(setDigiStatus())
    //     if (digiReloadStatus == true) {
    //         console.log("useEffect 2")
    //         navigate('/step-4')
    //     }
    // }, [digiReloadStatus])

 React.useEffect(() => {
   

    if (
        (userData?.steps?.["DigiLocker KYC verified Docs"]?.status) 
     
    ) {
      // Move to next step or show success
      const nextStep = activeStep + 1;
      if (nextStep < steps.length) {
        dispatch(setActiveStep(nextStep));
        navigate(steps[nextStep].path);
      }
    }
  }, [userData]);



      // Sync step with URL path
      React.useEffect(() => {
        const currentStep = steps.findIndex(
          (step) => step.path === location.pathname
        );
        if (currentStep !== -1) dispatch(setActiveStep(currentStep));
      }, [location.pathname, setActiveStep]);


    React.useEffect(() => {
        console.log("useEffect 1")
        const responseData = searchParams.get('data');
        console.log("URL", responseData)

        if (!responseData) {
            console.error('No encrypted data found in the query string.');
            return;
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "digilocker_captured",
            page_path: window.location.pathname
        });

        console.log("Encrypted Data:", responseData);

        const baseUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, baseUrl);

        const decryptResponse = (encryptedData) => {
            try {
                const secretKey = "96358214256984120";
                const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);

                // Convert bytes to string (UTF-8)
                const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

                return decryptedData ? JSON.parse(decryptedData) : null; // Parse JSON if valid
            } catch (error) {
                console.error("Decryption failed:", error);
                return null;
            }
        };

        const decryptedResponse = decryptResponse(responseData);

        console.log(decryptedResponse.code,decryptedResponse,"decryptedResponse")


        if (decryptedResponse) {
            if (decryptedResponse.code == "1") {
                if (decryptedResponse?.guardian ){
                    dispatch(setGuardian(decryptedResponse?.guardian))
                }
                dispatch(setDigiStepStatus())
                dispatch(setDigilockerCompleted())
                // dispatch(setDigiReload())
                // dispatch(setFaceMatchToTrue())
                dispatch(setDigiStepStatus())
                navigate('/step-3')
            } else if (decryptedResponse.code == "2") {
                dispatch(setDigiStatus(decryptedResponse.message))
                dispatch(setDisplay())
                // dispatch(setDigiButtonClicked())
            } else if (decryptedResponse.code == "3") {
                if (decryptedResponse?.guardian) {
                    dispatch(setGuardian(decryptedResponse?.guardian))
                }
                // if (!decryptedResponse.aadhaar && !decryptedResponse.pan) {
                //     dispatch(setDigiStatus(""))
                //     dispatch(setDigiError())
                // }
                if (!decryptedResponse.aadhaar) {
                    dispatch(setDigiStatus(decryptedResponse.message))
                    dispatch(setDisplay())
                    // dispatch(setDigiStatus("You denied Aadhaar access.Please upload your Aadhaar image manually."))
                    // dispatch(setDisplay())
                    // dispatch(setAadhaarOcrToTrue())
                    // dispatch(setDigiAadharStatus())
                }  
                else if(!decryptedResponse.pan){
                    dispatch(setDigiandmanualStatus("You denied Pan access.Please upload your Pan image manually."))
                    dispatch(setPanOcrToTrue())
                    dispatch(setDigiPanStatus())
                } 
            }
        } else {
            console.error("Failed to decrypt or parse data.");
        }
 

        // if (decryptedResponse) {
        //     console.log("useEffect 1")
        //     console.log("Decrypted Dataaa:", decryptedResponse);
        //     // dispatch(setDigiDataTONull())
        //     if (decryptedResponse.success == true) {
        //         console.log("useEffect 1 1 1")
        //         if (decryptedResponse.aadhaar == false && decryptedResponse.pan == false) {
        //             console.log("useEffect 1 2")
        //             dispatch(setDigiManualUploadStatus())
        //             dispatch(setBackButton())
        //             dispatch(setUploadTypeToManual())
        //         } else {
        //             dispatch(setDigiandmanualStatus())
        //             console.log("useEffect 1 3")
        //             if (decryptedResponse.aadhaar && decryptedResponse.pan) {
        //                 dispatch(setDigiStepStatus())
        //                 dispatch(setDigiReload())
        //                 dispatch(setFaceMatchToTrue())
        //                 navigate('/step-3')

        //             } else if (decryptedResponse.aadhaar == false) {
        //                 console.log("aadhar")
        //                 dispatch(setDigiAadharStatus())
        //             }
        //             else if (decryptedResponse.aadhaar == true) {
        //                 console.log("aadharTrueDD")
        //                 dispatch(setFaceMatchToTrue())
        //             } else if (decryptedResponse.pan == false) {
        //                 console.log("pan")
        //                 dispatch(setDigiPanStatus())
        //             } else {
        //                 dispatch(setAadharandPanStatus())
        //             }
        //         }
        //     }
        //     else if (decryptedResponse.success == false) {
        //         console.log("else part")
        //         dispatch(setDigiManualUploadStatus())
        //         dispatch(setBackButton())
        //         dispatch(setUploadTypeToManual())

        //     }

        // } else {
        //     console.error("Failed to decrypt or parse data.");
        // }

    }, [searchParams]);
 



    React.useEffect(() => {

        console.log("useEffect 3", digiDisp, !digiDisp, digilockerData)
        if (digilockerData && !digiDisp && !backToDigi) {
                console.log("useEffect 3 1")

                if (digilockerData.aadhaar && digilockerData.pan) {
                    dispatch(setDigiStepStatus())
                    dispatch(setDigilockerCompleted())
                    navigate('/step-3')
                    // dispatch(setDigiandmanualStatus())
                    // console.log("useEffect 3 3")
                    // if (digilockerData.aadhaar && digilockerData.pan) {
                    //     dispatch(setDigiStepStatus())
                    //     navigate('/step-3')
                    //     // dispatch(setFaceMatchToTrue())
                    // }
                    //  else if (digilockerData.aadhaar == false) {
                    //     console.log("aadhar false")
                    //     dispatch(setDigiStatus())
                      
                    // }
                    // else if (digilockerData.pan == false) {
                    //     console.log("Pan false")
                    //     dispatch(setDigiandmanualStatus())
                    // }
                }
                else if ((!digilockerData.aadhaar && !digilockerData.pan && !backToDigi) || (digilockerData.aadhaar == false && !backToDigi) ) {
                    dispatch(setDigiStatus(""))
                    // dispatch(setDigiError())
                }
                else if (digilockerData.pan == false && !backToDigi){
                    dispatch(setDigiandmanualStatus("You denied Pan access.Please upload your Pan image manually."))
                    dispatch(setPanOcrToTrue())
                    dispatch(setDigiPanStatus())
                }
                else {
                    console.log("useEffect 3 else")
                    dispatch(setDigiStatus())
                    dispatch(setDisplay())
                    // dispatch(setDigiButtonClicked())
                    // dispatch(setDigiManualUploadStatus())
                    // dispatch(setBackButton())
                    // dispatch(setUploadTypeToManual())
                    //  dispatch(setAadharandPanStatus())
                }
            }


    }, [digilockerData]);


    React.useEffect(() => {
        const processOcr = async () => {
            if (panFileName && panData && panFiletype && !panOcrValidated) {
                console.log("Processing OCR");
                await handlePanOcr();
            }
        };

        if (panFileName && panData && panFiletype) {
            processOcr();
        }
    }, [panFiletype, panData, panFileName,panOcrValidated]);

    // React.useEffect(() => {
    //     const processAadhaar = async () => {
    //         // Step 1: Check if both Aadhaar sides are uploaded
    //         console.log("Check if both Aadhaar sides are uploaded", aadharFrontFileName, aadharBackFileName);
    //         if (
    //             aadharFrontFileName &&
    //             aadharFrontData &&
    //             aadharBackFileName &&
    //             aadharBackData 
    //         ) {
    //             console.log("Merging Aadhaar Images...");
    //             await mergeAadhaarImages(); // sets aadharData
    //         }
    //     };

    //     processAadhaar();
    // }, [
    //     aadharFrontFileName,
    //     aadharFrontData,
    //     aadharBackFileName,
    //     aadharBackData,

    // ]);


    React.useEffect(() => {
        console.log("Merging Aadhaar Images firstttt...", ocrValidated, aadharBackFileName, aadharFrontFileName);
        const processAadhaar = async () => {
            if (aadharFrontFileName && aadharFrontData && aadharBackFileName && aadharBackData) {
                console.log("Merging Aadhaar Images...");
                await mergeAadhaarImages(); // this will setAadharData
                setOcrValidated(false); // reset validation since new file uploaded
            }
        };
        processAadhaar();
    }, [aadharFrontFileName, aadharFrontData, aadharBackFileName, aadharBackData]);

    // React.useEffect(() => {
    //     const runOcr = async () => {
    //         if (aadharData) {
    //             console.log("Running OCR validation...");
    //             await handleAadharOcr();
    //         }
    //     };

    //     runOcr();
    // }, [aadharData]);

    React.useEffect(() => {
        const runOcr = async () => {
            if (aadharData && !ocrValidated) {
                console.log("Running OCR validation...");
                await handleAadharOcr();
            }
        };
        runOcr();
    }, [aadharData, ocrValidated]);


    React.useEffect(() => {
        // console.log("useEffect button manual upload button aadhar" ,aadharUpload)
        // console.log("useEffect button manual upload button 1", panUpload)
        console.log("useEffect button manual upload button 1")

        if (aadharUpload && panUpload) {
            console.log("useEffect button manual upload button 2")
            setEnable(true)
        }
    }, [aadharUpload, panUpload]);


    // React.useEffect(() => {
    //     console.log("useEffect button enable")
    //     const isAadharValid = aadharStatus ? aadharData : true;
    //     const isPanValid = panStatus ? panData : true;
    //     setEnable(Boolean(isAadharValid && isPanValid));
    // }, [aadharStatus, panStatus, aadharData, panData]);

    const handlePicFile = async (file, type) => {
        if (!file) {
            console.error("No file selected.");
            if (type === "aadharFront") {
                setAadharUpload("")
                setAadhaarFrontVerify(false)
                setEnable(false)
                setAadharFrontError("No file selected.");
                setAadhaarEnable(false)


            }
            if (type === "aadharBack") {
                setAadharUpload("")
                setAadharFrontData("")
                setAadhaarBackVerify(false)
                setEnable(false)
                setAadharBackError("No file selected.");
                setAadhaarEnable(false)
            }
            if (type === "pan") {
                setPanUpload("")
                setPanVerify(false)
                setEnable(false)
                setPanError("No file selected.");
                setPanEnable(false)
            }
            return;
        }

        const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!validImageTypes.includes(file.type)) {
            const errorMessage = "Invalid file type. Please upload an image (JPEG, PNG, JPG).";
            if (type === "aadharFront") {
                setAadhaarFrontVerify(false)
                setAadharUpload("")
                setEnable(false)
                setAadharFrontError(errorMessage);
                setAadharFrontFileName("");
                setAadharFrontData(null); // Clear previous data
                setAadhaarEnable(false)
            }

            if (type === "aadharBack") {
                setAadhaarBackVerify(false)
                setAadharUpload("")
                setEnable(false)
                setAadharBackError(errorMessage);
                setAadharBackFileName("");
                setAadharBackData(null); // Clear previous data
                setAadhaarEnable(false)

            }
            if (type === "pan") {
                setPanVerify(false)
                setPanUpload("")
                setEnable(false)
                setPanError(errorMessage);
                setPanFileName("");
                setPanData(null); // Clear previous data
                setPanEnable(false)
            }
            return;
        }

        const maxSize = 5 * 1024 * 1024; // 5 MB
        if (file.size > maxSize) {
            const errorMessage = "File size exceeds the 5MB limit.";
            if (type === "aadharFront") {
                setAadharUpload("")
                setAadhaarFrontVerify(false)
                setEnable(false)
                setAadharFrontError(errorMessage);
                setAadharFrontFileName("");
                setAadharFrontData(null); // Clear previous data
                setAadhaarEnable(false)
            }
            if (type === "aadharBack") {
                setAadharUpload("")
                setAadhaarBackVerify(false)
                setEnable(false)
                setAadharBackError(errorMessage);
                setAadharBackFileName("");
                setAadharBackData(null); // Clear previous data
                setAadhaarEnable(false)

            }
            if (type === "pan") {
                setPanUpload("")
                setPanVerify(false)
                setEnable(false)
                setPanError(errorMessage);
                setPanEnable(false)
                setPanFileName("");
                setPanData(null); // Clear previous data
            }
            return;
        }

        try {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                const base64Image = fileReader.result.split(",")[1];
                const data = `data:image/jpeg;base64,${base64Image}`;

                setCrop({
                    modal: true,
                    image: data,
                    fileType: type
                })
                if (type === "aadharFront") {
                    setAadharUpload("")
                    setAadharFrontData("")
                    setAadhaarFrontVerify(false)
                    setAadharFrontFileName(file.name);
                    setAadharFrontError("");
                    setAadhaarEnable(false)
                    setAadharBackError("");
                } else if (type === "aadharBack") {
                    setAadhaarBackVerify(false)
                    setAadharBackFileName(file.name);
                    setAadharBackData("")
                    setAadharBackError("");
                    setAadhaarEnable(false)
                    setAadharBackError("");
                } else if (type === "pan") {
                    setPanUpload("")
                    setPanVerify(false)
                    setEnable(false)
                    setPanFileName(file.name);
                    setPanError("");
                    setPanEnable(false)
                    setEnable(false)
                    const fileType = file.type.split("/")[1] === "jpeg" ? "jpg" : file.type.split("/")[1];
                    setPanFiletype(fileType);
                    setPanFileName(file.name);
                    setPanError("");
                    setPanEnable(false)
                }

                // Update enable state after both aadharData and panData are valid
                // setEnable((aadharStatus ? Boolean(aadharData || type === "aadhar") : true) &&
                //     (panStatus ? Boolean(panData || type === "pan") : true));
            };

            fileReader.readAsDataURL(file);
        } catch (error) {
            console.error("Error reading file:", error);
            if (type === "aadharFront" || "aadharBack") {
                setAadharUpload("")
                setAadhaarFrontVerify(false)
                setAadhaarBackVerify(false)
                setAadharBackError("Error reading the file.");
                setAadhaarEnable(false)
            }
            if (type === "pan") {
                setPanUpload("")
                setPanVerify(false)
                setPanError("Error reading the file.");
                setPanEnable(false)
            }
        }
    };

    const fileTypeMap = {
        aadharFront: { dataKey: "aadharFrontData" },
        aadharBack: { dataKey: "aadharBackData" },
        pan: { dataKey: "panData" },
    };


    const handleSubmit = () => {
        const { fileType } = crop;
         
        const key = fileType

        const mapping = fileTypeMap[key];
        if (!mapping) {
            console.warn("Invalid fileType:", fileType);
            return;
        }

        const cropper = cropperRef.current;
        if (cropper) {
            const canvas = cropper.getCanvas();
            if (canvas) {
                const dataUrl = canvas.toDataURL();
                console.log("dataUrl", mapping.dataKey, dataUrl);

                if (key =="aadharFront"){
                    console.log("aadharFront")
                    setAadharFrontData(dataUrl)
                    setAadhaarEnable(false)
                }
                else if (key == "aadharBack"){
                    console.log("aadharback")
                    setAadharBackData(dataUrl)
                    setAadhaarEnable(false)
                }else{
                    setPanData(dataUrl)
                    setPanOcrValidated(false)
                }
                setCrop({ modal: false, image: "", fileType: "" });
            }
        }
    };



    const handleCropCancel = () => {
        console.log("closeeeeeeee");
        console.log("crop state:", crop);
        console.log("fileType from crop:", crop.fileType);

        const { fileType } = crop;

        if (!fileType || !fileTypeMap[fileType]) {
            console.warn("Invalid fileType:", fileType);
        } else {
            const { nameKey, dataKey } = fileTypeMap[fileType];
            console.log("resetting:", nameKey, dataKey);
        }

        // Always clear Aadhaar data if cancelling
        if (fileType == "aadharFront") {
            console.log("aadharFront")
            setAadharFrontData("")
            setAadharFrontFileName("")
        }
        else if (fileType == "aadharBack") {
            setAadharBackData("")
            setAadharBackFileName("")
        } else {
            setPanData("")
            setPanFileName("")
        }
      
        

        // Close modal
        setCrop({
            modal: false,
            image: "",
            fileType: "",
        });
    };


    const mergeAadhaarImages = async () => {
       
        if (aadharFrontData.length === 0 && aadharBackData.length === 0) {
            return '';
        }
        const loadImage = (src) =>
            new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => resolve(img);
                img.onerror = reject;
                img.src = src;
            });

        try {
            const img1 = await loadImage(aadharFrontData);
            const img2 = await loadImage(aadharBackData);

            const canvas = document.createElement('canvas');
            const width = Math.max(img1.width, img2.width);
            const height = img1.height + img2.height;

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext('2d');
            ctx.fillStyle = "#FFFFFF";
            ctx.fillRect(0, 0, width, height);
            ctx.drawImage(img1, 0, 0);
            ctx.drawImage(img2, 0, img1.height);

            const mergedBase64 = canvas.toDataURL("image/png");
            console.log("mergedBase64", mergedBase64)
             setAadharData(mergedBase64)

        } catch (err) {
            console.error("❌ Failed to merge Aadhaar images", err);
        }
    };



    const handleAadharOcr = async () => {
        
        console.log("Payload:", email, mobile, "png", aadharData);
        setAadhaarFrontVerify(false)
        setAadhaarBackVerify(false)
        setPanFileUploader(false)
        setAadhaarFileUploader(false)
        setEnable(false)
        try {
            const response = await dispatch(
                ocrCheck({
                    mobile,
                    email,
                    filetype:"png",
                    base64: aadharData,
                    type: "aadhaar"
                })
            ).unwrap();

            console.log("Response:", response.data);

            if (response.data.response.success) {
                // setAadharFrontFileName("");
                // setAadhaarFrontFiletype("");
                // setAadharBackFileName("");
                // setAadhaarBackFiletype("");
                // setAadharBackData("")
                // setAadharFrontData("")
                setAadharUpload(aadharData)
                setAadhaarFrontVerify(true)
                setAadhaarBackVerify(true)
                setAadhaarEnable(true)
                setAadharData("");
                setPanFileUploader(true)
                setAadhaarFileUploader(true)
                setOcrValidated(true)  
                if (aadhaarOcr) {
                    handlAadhaarUpload(aadharData)
                }
            } else {
                setPanFileUploader(true)
                setAadhaarFileUploader(true)
                setAadharFrontFileName("");
                setAadhaarFrontFiletype("");
                setAadharBackFileName("");
                setAadhaarBackFiletype("");
                setAadharUpload("")
                setAadharBackData("");
                setAadharFrontData("");
                setAadharData("");
                setAadhaarFrontVerify(false)
                setAadhaarBackVerify(false)
                setAadhaarEnable(false);
                setAadharBackError(response.data.response.message);
            }
        } catch (error) {
            setAadharBackData("")
            setAadharFrontData("")
            setAadharFrontFileName("");
            setAadhaarFrontFiletype("");
            setAadharBackFileName("");
            setAadhaarBackFiletype("");
            setPanFileUploader(true)
            setAadhaarFileUploader(true)
            setAadhaarFrontVerify(false)
            setAadhaarBackVerify(false)
            console.error("Bank verification failed:", error);
            setAadharBackError("Ocr failed")
            setAadhaarEnable(false);

        }
    };


    const handlePanOcr = async () => {
        setPanFileUploader(false)
        setAadhaarFileUploader(false)
        setEnable(false)
        console.log("Payload:", email, mobile, panFiletype);

        try {
            const response = await dispatch(
                ocrCheck({
                    mobile,
                    email,
                    filetype: panFiletype,
                    base64: panData,
                    type: "pan"
                })
            ).unwrap();

            console.log("Response:", response.data);

            if (response.data.response.success) {
                setPanUpload(panData)
                // setPanFileUploader(true)
                // setAadhaarFileUploader(true)
                setPanVerify(true)
                setPanFiletype("");
                setPanEnable(true)
                setPanOcrValidated(true)
                if(panOcr){
                   handlPanUpload()
                }
            }else {
                setPanUpload("")
                setPanFileUploader(true)
                setAadhaarFileUploader(true)
                setPanFileName("");
                setPanFiletype("");
                setPanData("");
                setPanEnable(false);
                setPanVerify(false)
                

                if(response.data.response.code == "1"){
                    setPanError("");
                    setPanFail(response.data.response.message)
                    dispatch(setDigiStatus())
                    dispatch(setDisplay())
                    
                }else{
                    setPanError(response.data.response.message);
                }
            }
        } catch (error) {
            setPanFileName("");
            setPanFiletype("");
            setPanFileUploader(true)
            setAadhaarFileUploader(true)
            setPanVerify(false)
            console.error("Ocr failed", error);
            // setPanError("Ocr failed")
            //added by dev-Ayush 22-07-2026 start
            const errMessage = error?.data?.data?.message
            setPanError(errMessage || "Ocr failed")
            //added by dev-Ayush 22-07-2026 end
            setPanEnable(false);
        }
    };


    const handlAadhaarUpload = async (data) => {

        console.log("helllooeoeoe", data)
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "digilocker_aadhar_upload",
            page_path: window.location.pathname
        });
        try {
            const result = await dispatch(aadhaarUploadDigilocker({
                mobile, email, aadharUpload : data
            })).unwrap();
            // Navigation will be handled by useEffect

            if (result.data.status == 200) {
                // console.log("result",result.data)

                if (digilockerData) {
                    if (result.data.resdata.aadhaar == true) {
                        console.log("result", result.data)
                        dispatch(setDigiDataAadhaarStatus())
                        dispatch(setAadharStatusTofalse())
                    }
                } else {
                    if (result.data.resdata.aadhaar == true) {
                        console.log("result 2", result.data)
                        dispatch(setAadharStatusTofalse())
                        dispatch(setDigiReload())
                    }
                }

                console.log("success")
                dispatch(setDigiStepStatus())
                dispatch(setDigiReload())
                dispatch(setDigilockerCompleted())
                const { payload } = await dispatch(checkAndNavigate());

                console.log(payload.allComplete)

                if (payload.allComplete) {
                    // All required steps completed - go to products
                    console.log("Navigating to dis page...")
                    navigate("/dis");
                } else {

                    // First check if there are incomplete steps forward (normal flow)
                    let nextIncompleteStep = null;

                    // Check forward steps first
                    for (let i = activeStep + 1; i < steps.length; i++) {
                        const step = steps[i];
                        const isComplete = step.substeps
                            ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                            : userData.steps[step.name]?.status;
                        console.log("Forward steps completed --->", isComplete)

                        if (!isComplete) {
                            nextIncompleteStep = step;
                            console.log("Forward steps Incomplete navigating to", JSON.stringify(step))
                            break;
                        }
                    }

                    // If no incomplete steps forward, check all steps
                    if (!nextIncompleteStep) {
                        console.log("No incomplete steps forward checking any in backward steps")
                        for (let i = 0; i < steps.length; i++) {
                            const step = steps[i];
                            const isComplete = step.substeps
                                ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                                : userData.steps[step.name]?.status;

                            if (!isComplete) {
                                nextIncompleteStep = step;
                                console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
                                break;
                            }
                        }
                    }

                    const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
                    console.log("Navigating to the specific step according to the condition", stepIndex)
                    if (stepIndex !== -1) {
                        dispatch(setActiveStep(stepIndex));
                        navigate(nextIncompleteStep.path);
                    }
                }
            }
        } catch (error) {
            setAadhaarFrontVerify(false)
            setAadhaarBackVerify(false)
            setAadhaarEnable(false)
            console.error('aadhar Upload failed:', error);
            setAadharBackError("Aadhaar upload failed")
        }
    }


    const handlPanUpload = async (e) => {
        // e.preventDefault()

        console.log("payload", panData)

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "digilocker_pan_upload",
            page_path: window.location.pathname
        });

        try {
            const result = await dispatch(panUploadDigilocker({
                mobile, email, panData
            })).unwrap();
            // Navigation will be handled by useEffect

            if (result.data.status == 200) {
                // console.log("result",result.data)

                if (digilockerData) {
                    if (result.data.resdata.pan == true) {
                        console.log("result pan", result.data)
                        dispatch(setDigiDataPanStatus())
                        dispatch(setPanStatusTofalse())
                    }
                } else {
                    if (result.data.resdata.pan == true) {
                        console.log("result pan 2", result.data)
                        dispatch(setPanStatusTofalse())
                        dispatch(setDigiReload())
                    }
                }
                setPanData("");
             
                 setPanFileUploader(true)
                setAadhaarFileUploader(true)
                dispatch(setDigiStepStatus())
                dispatch(setDigiReload())
                dispatch(setDigilockerCompleted())
                console.log("success")
                const { payload } = await dispatch(checkAndNavigate());

                console.log(payload.allComplete)

                if (payload.allComplete) {
                    // All required steps completed - go to products
                    console.log("Navigating to dis page...")
                    navigate("/dis");
                } else {

                    // First check if there are incomplete steps forward (normal flow)
                    let nextIncompleteStep = null;

                    // Check forward steps first
                    for (let i = activeStep + 1; i < steps.length; i++) {
                        const step = steps[i];
                        const isComplete = step.substeps
                            ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                            : userData.steps[step.name]?.status;
                        console.log("Forward steps completed --->", isComplete)

                        if (!isComplete) {
                            nextIncompleteStep = step;
                            console.log("Forward steps Incomplete navigating to", JSON.stringify(step))
                            break;
                        }
                    }

                    // If no incomplete steps forward, check all steps
                    if (!nextIncompleteStep) {
                        console.log("No incomplete steps forward checking any in backward steps")
                        for (let i = 0; i < steps.length; i++) {
                            const step = steps[i];
                            const isComplete = step.substeps
                                ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                                : userData.steps[step.name]?.status;

                            if (!isComplete) {
                                nextIncompleteStep = step;
                                console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
                                break;
                            }
                        }
                    }

                    const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
                    console.log("Navigating to the specific step according to the condition", stepIndex)
                    if (stepIndex !== -1) {
                        dispatch(setActiveStep(stepIndex));
                        navigate(nextIncompleteStep.path);
                    }
                }
            }
        } catch (error) {
            setPanEnable(false)
            setPanVerify(false)
            setPanError("Pan upload Failed")
            console.error('Pan upload Failed', error);
        }
    }



    const handleBothAbsentUpload = async () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "digilocker_manual_captured",
            page_path: window.location.pathname
        });
        try {
            const result = await dispatch(absentUploadDigilocker({
                mobile, email, uploadType, panUpload, aadharUpload
            })).unwrap();
            // Navigation will be handled by useEffect

            if (result.data.status == 200) {
                // console.log("result",result.data)

                if (digilockerData) {
                    // if (result.data.resdata.pan == true) {
                    //     console.log("result pan", result.data)
                    //     dispatch(setDigiDataPanStatus())
                    //     dispatch(setPanStatusTofalse())
                    // }
                    dispatch(setDigiDataBothStatus())
                    dispatch(setBothStatusTofalse())
                } else {
                    dispatch(setBothStatusTofalse())
                    // if (result.data.resdata.pan == true) {
                    //     console.log("result pan 2", result.data)
                    //     dispatch(setPanStatusTofalse())
                    //     dispatch(setDigiReload())
                    // }
                }
                console.log("success")
                dispatch(setDigiStepStatus())
                dispatch(setDigiReload())
                dispatch(setDigilockerCompleted())
                const { payload } = await dispatch(checkAndNavigate());

                console.log(payload.allComplete)

                if (payload.allComplete) {
                    // All required steps completed - go to products
                    console.log("Navigating to dis page...")
                    navigate("/dis");
                } else {

                    // First check if there are incomplete steps forward (normal flow)
                    let nextIncompleteStep = null;

                    // Check forward steps first
                    for (let i = activeStep + 1; i < steps.length; i++) {
                        const step = steps[i];
                        const isComplete = step.substeps
                            ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                            : userData.steps[step.name]?.status;
                        console.log("Forward steps completed --->", isComplete)

                        if (!isComplete) {
                            nextIncompleteStep = step;
                            console.log("Forward steps Incomplete navigating to", JSON.stringify(step))
                            break;
                        }
                    }

                    // If no incomplete steps forward, check all steps
                    if (!nextIncompleteStep) {
                        console.log("No incomplete steps forward checking any in backward steps")
                        for (let i = 0; i < steps.length; i++) {
                            const step = steps[i];
                            const isComplete = step.substeps
                                ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                                : userData.steps[step.name]?.status;

                            if (!isComplete) {
                                nextIncompleteStep = step;
                                console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
                                break;
                            }
                        }
                    }

                    const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
                    console.log("Navigating to the specific step according to the condition", stepIndex)
                    if (stepIndex !== -1) {
                        dispatch(setActiveStep(stepIndex));
                        navigate(nextIncompleteStep.path);
                    }
                }
            }
        } catch (error) {
            setEnable(false)
            setPanVerify(false)
            setAadhaarFrontVerify(false)
            setAadhaarBackVerify(false)
            // setPanError("Pan upload Failed")
            console.error('Document upload aadhaar and Pan Failed', error);
        }
    }

    

    const handleDigiPageToManualPage = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "digilocker_manual_initiated",
            page_path: window.location.pathname
        });
        dispatch(setDigiManualUploadStatus())
        dispatch(setUploadTypeToManual())
    }


    // const handleManualToDigiPage = () => {
    //     dispatch(setDigiManualUploadStatusToFalse())
    //     dispatch(setUploadTypeToAbsent())
    //     setAadharFrontFileName("")
    //     setPanFileName("")
    //     setAadhaarFrontVerify(false)
    //     setAadhaarBackVerify(false)
    //     setPanVerify(false)
    //     setEnable(false)
    // }

    const handleNext = async() => {
        const { payload } = await dispatch(checkAndNavigate());

        console.log(payload.allComplete)

        if (payload.allComplete) {
            // All required steps completed - go to products
            console.log("Navigating to dis page...")
            navigate("/dis");
        } else {

            // First check if there are incomplete steps forward (normal flow)
            let nextIncompleteStep = null;

            // Check forward steps first
            for (let i = activeStep + 1; i < steps.length; i++) {
                const step = steps[i];
                const isComplete = step.substeps
                    ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                    : userData.steps[step.name]?.status;
                console.log("Forward steps completed --->", isComplete)

                if (!isComplete) {
                    nextIncompleteStep = step;
                    console.log("Forward steps Incomplete navigating to", JSON.stringify(step))
                    break;
                }
            }

            // If no incomplete steps forward, check all steps
            if (!nextIncompleteStep) {
                console.log("No incomplete steps forward checking any in backward steps")
                for (let i = 0; i < steps.length; i++) {
                    const step = steps[i];
                    const isComplete = step.substeps
                        ? step.substeps.every(sub => userData.steps[sub.name]?.status)
                        : userData.steps[step.name]?.status;

                    if (!isComplete) {
                        nextIncompleteStep = step;
                        console.log("Backward steps Incomplete navigating to", JSON.stringify(step))
                        break;
                    }
                }
            }

            const stepIndex = steps.findIndex(s => s.path === nextIncompleteStep.path);
            console.log("Navigating to the specific step according to the condition", stepIndex)
            if (stepIndex !== -1) {
                dispatch(setActiveStep(stepIndex));
                navigate(nextIncompleteStep.path);
            }
        }
    };



    const handleContinue = async (e,value) => {
        e.preventDefault();
        console.log("value",value)
        setPanFail("")
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "kyc_step_viewed",
            step_name: "digilocker_initaite",
            page_path: window.location.pathname
        });
        try {
            const result = await dispatch(digilocker({
                mobile, email,value
            })).unwrap();
            // Navigation will be handled by useEffect
            dispatch(setDigiData(null))
            console.log("result", result.data.data.url)
            const url = result.data.data.url;
            window.location.href = url;
            // localStorage.setItem("displayButton", "true");
                  
        } catch (error) {
            console.error('Bank verification failed:', error);
        }
    }

    // React.useEffect(()=>{
    //     const savedDisplayButton = localStorage.getItem("displayButton");
    //     if (savedDisplayButton === "true") {
    //         console.log("111")
    //         dispatch(setDigiButtonClicked());
    //     }
    // },[])

    const handleSkip = () => {
        if (activeStep < steps.length - 1) {
            const nextStep = activeStep + 1;
            dispatch(setActiveStep(activeStep + 1));
            navigate(steps[nextStep].path);
        }
    };

    // const handleStepNavigate = (path) => {
    //     const stepIndex = steps.findIndex((step) => step.path === path);
    //     if (stepIndex !== -1) {
    //         dispatch(setActiveStep(stepIndex));
    //         navigate(path);
    //     }
    // };

    const handleStepNavigate = (path) => {
    // Only check for PAN verification now
    if (path !== "/step-2" && !( userData?.steps?.["DigiLocker KYC verified Docs"]?.status))
      //  &&
      // (aadharVerified === "true" || userData?.steps?.["Aadhaar Verify"]?.status))) 
      {
      // window.alert("Please complete PAN verification before proceeding to other steps");
      showMessage("Please complete PAN and KYC verification before proceeding", "warning");
      return;
    }

    // const stepIndex = steps.findIndex((step) => step.path === path);
    // if (stepIndex !== -1) {
    //   dispatch(setActiveStep(stepIndex));
    //   navigate(path);
    // }
  };
    return (
        <main key={refresh}>

        {
                digilockerCompleted  ?    <Grid2
                    sx={{
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundImage: `url(${SignUpBg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        "@media (max-width:600px)": {
                            justifyContent: "start"
                        }
                    }}
                >
                <Box
                    sx={{
                        position: "absolute",
                        top: "35%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: {
                            xs: "70%",
                            sm: "60%",
                            md: "40%",
                        },
                        bgcolor: "background.paper",
                        borderRadius: 5,
                        boxShadow: 24,
                        p: 3,
                        textAlign: "center",
                        "@media (max-width:600px)": {
                            top: "45%",
                            p: 3,
                        },
                    }}
                >
                    <Box sx={{ textAlign: "center", mb: 2 }}>
                        <img src={errorIcon} alt="modalIcon" className={NumOtpStyles.img} />
                    </Box>

                    <Typography className={NumOtpStyles.retakeErrorSubTxt}>
                        This step has already been completed. You can proceed to the next step.
                    </Typography>

                    <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
                        <Button
                            variant="contained"
                            className={DigilockerStyles.nxtBtn}
                            onClick={handleNext}   // change based on your function
                        >
                            Continue
                        </Button>
                    </Box>
                </Box>

            </Grid2> 
            :
            <Box sx={{
                 display: "flex",
                 flexDirection:isMobile ? "column" : "row",
                  minHeight: "100vh !important",
                  backgroundImage: `url(${SignUpBg})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
            }}>

                <Typography
                    sx={{
                        textAlign: "center",
                        fontSize: "16px",
                        fontFamily: "Inter400",
                        display: {
                            xs: "block", // shown on small screens
                        },
                        mt: "5px",
                        "@media (min-width:1000px)": {
                            display: "none"
                        }
                    }}
                >
                    {`You are on step ${activeStep + 1} out of 8`}
                </Typography>
                
                <StepperCard
                    activeStep={activeStep}
                    handleStepNavigate={handleStepNavigate}
                    backendResponse={backendResponse}
                    CustomStepConnector={CustomStepConnector}
                    StepIcon={StepIcon}
                    steps={steps}
                />
                  
                <Box className={DigilockerStyles.content_wrapper}>

                    {
                        digiStatus &&
                        <>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                                flexDirection:"column",
                                width: '100%',
                                // marginBottom: '10px',
                                marginTop: '20px',
                                
                            }}>
                                {/* Back arrow button - only shows below 1000px */}
                                {/* <Box sx={{
                                    position: 'absolute',
                                    left: 0,

                                    '@media (min-width: 1000px)': {
                                        display: 'none' // Explicitly hide above 1000px
                                    }
                                }}>
                                    <IconButton
                                        onClick={() => navigate('/step-2')} // Or your custom back handler
                                        sx={{
                                            color: '#000', // Customize color
                                            padding: '16px'
                                        }}
                                    >
                                        <ArrowBack /> 
                                    </IconButton>
                                </Box> */}

                                {/* Logo - centered */}
                                <img
                                    src={source == "cosmos"? collab: navLogo}
                                    alt="Logo"
                                    style={{
                                        // Adjust margin to account for arrow on mobile
                                        marginLeft: { xs: '40px', md: 0 }
                                    }}
                                    className={source == "cosmos" ? DigilockerStyles.twologo : DigilockerStyles.nav_logo}
                                />
                                {
                                    source == "cosmos" &&
                                            <Typography className={DigilockerStyles.txt1}>
                                        Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
                                    </Typography>
                                }
                            </Box>
                            <Typography className={DigilockerStyles.heading}>
                                Digilocker Documents for KYC
                            </Typography>

                           

                            <img
                                    src={digilogo}
                                    alt="digilockerlogo"
                                    className={DigilockerStyles.digi_logo}
                                />

                          


                                <Typography className={DigilockerStyles.title}>
                                    Digilocker automatically verifies your documents needed for KYC and
                                    account opening on Tradeboss
                                </Typography>

                            <Typography
                                className={DigilockerStyles.sub_title}
                            >
                                Tradeboss uses digilocker to fetch your documents
                            </Typography>
                            <Typography className={DigilockerStyles.title1}>
                                I provide my consent to share my Aadhaar number, date of birth, and name from my Aadhaar eKYC information with the Income Tax Department and all State authorities for the purpose of fetching my PAN verification record into DigiLocker.
                            </Typography>
                         

                        {/* 
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    // position: "absolute",
                                    // bottom: "-20px", // Adjust based on spacing requirements
                                    // right: "0px", // Align to the right of the parent container
                                }}
                            >
                               
                                <img
                                    src={lock}
                                    alt="locker"
                                    style={{
                                        width: "10px",
                                        height: "12.5px",
                                        padding: "20px 0px 10px 0px",
                                    }}
                                />
                               
                            </Box> */}

                         

                            {/* <Grid2 item xs={12} sm={6}>
                                <Button
                                    className={DigilockerStyles.con_button}
                                    onClick={(e)=>{handleContinue(e,"Setu")}}

                                >
                              
                               I Agree
                                </Button>
                            </Grid2> */}

                            <Grid2 item xs={12} sm={6}>
                                <Button
                                    className={DigilockerStyles.con_button}
                                    onClick={(e) => { handleContinue(e, "Setu") }}

                                >
                                    I Agree
                                </Button>
                            </Grid2>
                            
                           {/* { 
                             digiButClicked 
                             &&
                              <Grid2 item xs={12} sm={6}>
                                <Button
                                sx={{marginTop:"10px"}}
                                    className={DigilockerStyles.manual_button}
                                        onClick={handleDigiPageToManualPage}

                                >
                                    Continue with Manual Upload
                                </Button>
                            </Grid2>
                            } */}
                            

                            {
                                digiError && <Typography
                                    // sx={{color:"#000000"}}
                                    className={DigilockerStyles.validation_error}
                                >
                                    {digiError}

                                    {/* You have denied consent to access your Aadhaar details via DigiLocker. Provide your consent, to proceed with KYC. */}
                                </Typography>
                            }



                            {
                                panFail && <Typography
                                    // sx={{color:"#000000"}}
                                    className={DigilockerStyles.validation_error}
                                >
                                    {panFail}
                                </Typography>
                            }

                            {/* <Box className={DigilockerStyles.orBox}>
                               
                                <Box className={DigilockerStyles.leftLine} />

                                <Typography className={DigilockerStyles.or}>OR</Typography>

                                <Box className={DigilockerStyles.rightLine} />
                            </Box>
                            <Typography className={DigilockerStyles.heading1}>
                                Manual Upload
                            </Typography>

                            <Typography className={DigilockerStyles.sub_title}>
                                Kindly ensure that you have a photocopy of your Aadhar and PAN card ready for upload in the following steps.
                            </Typography>


                            <Button className={DigilockerStyles.manual_button}
                                onClick={handleDigiPageToManualPage}>
                                Continue With Manual Upload
                            </Button> */}



                        </>
                    }



                    {
                        manualStatus &&
                        <>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                                width: '100%',
                                marginBottom: '10px',
                                marginTop: '10px',
                            }}>
                               
                                {/* <Box sx={{
                                    position: 'absolute',
                                    left: 0,

                                    '@media (min-width: 1000px)': {
                                        display: 'none' // Explicitly hide above 1000px
                                    }
                                }}>
                                    <IconButton
                                        onClick={() => navigate('/step-2')} // Or your custom back handler
                                        sx={{
                                            color: '#000', // Customize color
                                            padding: '16px'
                                        }}
                                    >
                                        <ArrowBack /> 
                                    </IconButton>
                                </Box> */}
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexDirection:"column"
                                            }}>
                                            <img
                                                src={source == "cosmos" ? collab : navLogo}
                                                alt="Logo"
                                                style={{
                                                    // Adjust margin to account for arrow on mobile
                                                    marginLeft: { xs: '40px', md: 0 }
                                                }}
                                                className={source == "cosmos" ? DigilockerStyles.twologo : DigilockerStyles.nav_logo}
                                            />
                                            {
                                                source == "cosmos" &&
                                                <Typography className={DigilockerStyles.txt1}>
                                                    Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
                                                </Typography>
                                            }

                                </Box>

                               
                               
                            </Box>

                            < Typography className={DigilockerStyles.upload_title}>
                                Upload Documents
                            </Typography>



                            {/* {
                                aadharStatus &&
                                <>

                                    {
                                        digiError && <Typography
                                            // sx={{color:"#000000"}}
                                            className={DigilockerStyles.validation_error}
                                        >
                                            {digiError}
                                        </Typography>
                                    }

                                    <Typography className={DigilockerStyles.aadhar_title}
                                        sx={{
                                            padding:"20px 10px 0px 10px"
                                        }}
                                       >
                                        Copy of valid Aadhaar card front side
                                    </Typography>
                                    <Typography className={DigilockerStyles.aadhar_subtitle}>Provide below documents in JPG or PNG form.</Typography>

                                    <Box sx={{ marginTop: "7px", position: "relative" }}>
                                       


                                        <FileUploader
                                            multiple={false}
                                            maxSize={"1mb"}
                                            hoverTitle="rAI"
                                            label="Upload or drop a file right here"
                                            name="file1"
                                            handleChange={(file) => {
                                                if (aadhaarFileUploader) handlePicFile(file, "aadharFront");
                                            }}
                                            disabled={!aadhaarFileUploader}
                                        >
                                            <Box
                                                className={DigilockerStyles.fileuploader}
                                                sx={{

                                                    border: aadhaarFileUploader
                                                        ? "2px dashed #aaa"
                                                        : "2px dashed #ccc",
                                                    borderRadius: "10px",
                                                    cursor: aadhaarFileUploader ? "pointer" : "not-allowed",
                                                    backgroundColor: aadhaarFileUploader
                                                        ? "transparent"
                                                        : "#f5f5f5",
                                                }}
                                            >
                                                <Typography
                                                    className={DigilockerStyles.fileuploader_txt}
                                                    color={aadhaarFileUploader ? "text.primary" : "text.disabled"}
                                                >
                                                    {aadhaarFileUploader
                                                        ? "Drag and Drop here / "
                                                        : "Uploader Disabled"}
                                                    {aadhaarFileUploader && (
                                                        <span
                                                            className={DigilockerStyles.fileuploader_txt1}

                                                        >
                                                            Browse File
                                                        </span>
                                                    )}
                                                </Typography>
                                            </Box>
                                        </FileUploader>

                                       
                                        <Box

                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                position: "absolute",
                                                bottom: "-20px", // Adjust based on spacing requirements
                                                right: "0px", // Align to the right of the parent container
                                            }}
                                        >
                                            <img
                                                src={lock}
                                                alt="locker"
                                                style={{
                                                    width: "10px",
                                                    height: "12.5px",
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontFamily: "Inter400",
                                                    fontSize: "14px",
                                                    lineHeight: "20px",
                                                    letterSpacing: "0px",
                                                    color: "#7A7C7F",
                                                    padding: "0px 0px 0px 5px",
                                                }}
                                            >
                                                Secure
                                            </Typography>
                                        </Box>
                                    </Box>


                                    <Grid2 style={{ display: "flex", flexDirection: "row" }}>
                                        {aadharFrontFileName && (
                                            <Typography
                                                style={{
                                                    marginTop: "10px ",
                                                    fontSize: "15px",
                                                    fontFamily: "Inter400 !important",
                                                    color: "#000000",
                                                }}
                                            >
                                                {aadharFrontFileName}
                                            </Typography>
                                        )}
                                        {
                                            aadhaarFrontVerify && <img src={verified} alt="logo" style={{
                                                marginTop: "12px", paddingLeft: "10px"
                                            }} />
                                        }
                                    </Grid2>


                                    {aadharFrontError && (
                                        <Typography
                                            className={DigilockerStyles.validation_error}
                                        >
                                            {aadharFrontError}
                                        </Typography>
                                    )}



                                    <Typography className={DigilockerStyles.aadhar_title}
                                       sx={{
                                           padding: (aadharFrontFileName || aadharFrontError) ? "10px 10px 0px 10px" :"30px 10px 0px 10px"
                                       }}>
                                        Copy of valid Aadhaar card back side
                                    </Typography>
                                    <Typography className={DigilockerStyles.aadhar_subtitle}>Provide below documents in JPG or PNG form.</Typography>

                                    <Box sx={{ marginTop: "7px", position: "relative" }}>



                                        <FileUploader
                                            multiple={false}
                                            maxSize={"1mb"}
                                            hoverTitle="rAI"
                                            label="Upload or drop a file right here"
                                            name="file1"
                                            handleChange={(file) => {
                                                if (aadhaarFileUploader) handlePicFile(file, "aadharBack");
                                            }}
                                            disabled={!aadhaarFileUploader}
                                        >
                                            <Box
                                                className={DigilockerStyles.fileuploader}
                                                sx={{

                                                    border: aadhaarFileUploader
                                                        ? "2px dashed #aaa"
                                                        : "2px dashed #ccc",
                                                    borderRadius: "10px",
                                                    cursor: aadhaarFileUploader ? "pointer" : "not-allowed",
                                                    backgroundColor: aadhaarFileUploader
                                                        ? "transparent"
                                                        : "#f5f5f5",
                                                }}
                                            >
                                                <Typography
                                                    className={DigilockerStyles.fileuploader_txt}
                                                    color={aadhaarFileUploader ? "text.primary" : "text.disabled"}
                                                >
                                                    {aadhaarFileUploader
                                                        ? "Drag and Drop here / "
                                                        : "Uploader Disabled"}
                                                    {aadhaarFileUploader && (
                                                        <span
                                                            className={DigilockerStyles.fileuploader_txt1}

                                                        >
                                                            Browse File
                                                        </span>
                                                    )}
                                                </Typography>
                                            </Box>
                                        </FileUploader>


                                        <Box

                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                position: "absolute",
                                                bottom: "-20px", // Adjust based on spacing requirements
                                                right: "0px", // Align to the right of the parent container
                                            }}
                                        >
                                            <img
                                                src={lock}
                                                alt="locker"
                                                style={{
                                                    width: "10px",
                                                    height: "12.5px",
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontFamily: "Inter400",
                                                    fontSize: "14px",
                                                    lineHeight: "20px",
                                                    letterSpacing: "0px",
                                                    color: "#7A7C7F",
                                                    padding: "0px 0px 0px 5px",
                                                }}
                                            >
                                                Secure
                                            </Typography>
                                        </Box>
                                    </Box>


                                    <Grid2 style={{ display: "flex", flexDirection: "row" }}>
                                        {aadharBackFileName && (
                                            <Typography
                                                style={{
                                                    marginTop: "10px ",
                                                    fontSize: "15px",
                                                    fontFamily: "Inter400 !important",
                                                    color: "#000000",
                                                }}
                                            >
                                                {aadharBackFileName}
                                            </Typography>
                                        )}
                                        {
                                            aadhaarBackVerify && <img src={verified} alt="logo" style={{
                                                marginTop: "12px", paddingLeft: "10px"
                                            }} />
                                        }
                                    </Grid2>

                                    {aadharBackError && (
                                        <Typography
                                            className={DigilockerStyles.validation_error}
                                        >
                                            {aadharBackError}
                                        </Typography>
                                    )} */}

                                  
                                    {/* <Grid2 className={DigilockerStyles.but_card}>
                                        <Grid2>
                                            <Button

                                                sx={{
                                                    backgroundColor: aadhaarEnable ? '#f3d45e' : '#C4C4C4',
                                                    width: '196px',
                                                    height: '52px',
                                                    borderRadius: '27px',
                                                    fontFamily: 'Inter700, sans-serif',
                                                    fontSize: '20px',
                                                    lineHeight: '22px',
                                                    color: '#000 !important',
                                                    textTransform: 'capitalize',
                                                    marginTop:"30px"
                                                }}

                                                onClick={aadhaarEnable ? handlAadhaarUpload : null}

                                            >
                                                {loading ? 'Verifying...' : 'Continue'}
                                            </Button>
                                        </Grid2>
                                    </Grid2>  */}
                                   
                                {/* </>
                            } */}


                            {
                                panStatus &&
                                <>

                                {
                                digiError && <Typography
                                // sx={{color:"#000000"}}
                                            className={DigilockerStyles.validation_error}
                                >
                                    {digiError}
                                </Typography>
                                }


                                {
                                panFail && <Typography
                                    // sx={{color:"#000000"}}
                                    className={DigilockerStyles.validation_error}
                                >
                                    {panFail}

                                    {/* You have denied consent to access your Aadhaar details via DigiLocker. Provide your consent, to proceed with KYC. */}
                                </Typography>
                            }

                            
                                    <Typography className={DigilockerStyles.pan_title}
                                        sx={{
                                            paddingTop: (aadharBackFileName || aadharBackError)? "10px" : "30px"
                                        }}>
                                        Manual Pan Upload
                                    </Typography>
                                    <Typography className={DigilockerStyles.pan_subtitle}>Provide below documents in JPG or PNG form.</Typography>

                                    <Box sx={{ marginTop: "7px", position: "relative" }}>
                                        


                                        <FileUploader
                                            multiple={false}
                                            maxSize={"1mb"}
                                            hoverTitle="rAI"
                                            label="Upload or drop a file right here"
                                            name="file1"
                                            handleChange={(file) => {
                                                if (panFileUploader) handlePicFile(file, "pan");
                                            }}
                                            disabled={!panFileUploader}
                                        >
                                            <Box
                                                className={DigilockerStyles.fileuploader}
                                                sx={{

                                                    border: panFileUploader
                                                        ? "2px dashed #aaa"
                                                        : "2px dashed #ccc",
                                                    cursor: panFileUploader ? "pointer" : "not-allowed",
                                                    backgroundColor: panFileUploader
                                                        ? "transparent"
                                                        : "#f5f5f5",
                                                }}
                                            >
                                                <Typography
                                                    className={DigilockerStyles.fileuploader_txt}
                                                    color={panFileUploader ? "text.primary" : "text.disabled"}
                                                >
                                                    {panFileUploader
                                                        ? "Drag and Drop here / "
                                                        : "Uploader Disabled"}
                                                    {panFileUploader && (
                                                        <span
                                                            className={DigilockerStyles.fileuploader_txt1}
                                                        >
                                                            Browse File
                                                        </span>
                                                    )}
                                                </Typography>
                                            </Box>
                                        </FileUploader>

                                    
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                position: "absolute",
                                                bottom: "-20px", // Adjust based on spacing requirements
                                                right: "0px", // Align to the right of the parent container
                                            }}
                                        >
                                            <img
                                                src={lock}
                                                alt="locker"
                                                style={{
                                                    width: "10px",
                                                    height: "12.5px",
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    fontFamily: "Inter400",
                                                    fontSize: "14px",
                                                    lineHeight: "20px",
                                                    letterSpacing: "0px",
                                                    color: "#7A7C7F",
                                                    padding: "0px 0px 0px 5px",
                                                }}
                                            >
                                                Secure
                                            </Typography>
                                        </Box>


                                    </Box>




                                    <Grid2 style={{ display: "flex", flexDirection: "row" }}>
                                        {panFileName && (
                                            <Typography
                                                style={{
                                                    marginTop: "10px ",
                                                    fontSize: "15px",
                                                    fontFamily: "Inter400 !important",
                                                    color: "#000000",
                                                }}
                                            >
                                                {panFileName}
                                            </Typography>
                                        )}
                                        {
                                            panVerify && <img src={verified} alt="logo" style={{
                                                marginTop: "12px", paddingLeft: "10px"
                                            }} />
                                        }
                                    </Grid2>
                                    {panError && (
                                        <Typography
                                            className={DigilockerStyles.validation_error}
                                        >
                                            {panError}
                                        </Typography>
                                    )}
                                    
                                        {/* <Grid2 className={DigilockerStyles.but_card}>
                                        <Grid2>
                                            <Button

                                                sx={{
                                                    backgroundColor: panEnable ? '#f3d45e' : '#C4C4C4',
                                                    width: '196px',
                                                    height: '52px',
                                                    borderRadius: '27px',
                                                    fontFamily: 'Inter700, sans-serif',
                                                    fontSize: '20px',
                                                    lineHeight: '22px',
                                                    color: '#000 !important',
                                                    textTransform: 'capitalize',
                                                    marginTop: "30px"
                                                }}

                                                onClick={panEnable ? handlPanUpload : null}

                                            >
                                                {loading ? 'Verifying...' : 'Continue'}
                                            </Button>
                                        </Grid2>
                                    </Grid2> */}
                                    
                                    
                                </>
                            }
                            {/* <Grid2 className={DigilockerStyles.but_card}>
                                    <Grid2>
                                        <Button

                                            sx={{
                                                backgroundColor: enable ? '#f3d45e' : 'grey',
                                                width: '196px',
                                                height: '52px',
                                                borderRadius: '27px',
                                                fontFamily: 'Inter700, sans-serif',
                                                fontSize: '20px',
                                                lineHeight: '22px',
                                                color: '#000 !important',
                                                textTransform: 'capitalize',
                                            }}
                                            disabled={!enable}

                                            onClick={enable ? handlUpload : null}

                                        >
                                            Continue
                                        </Button>
                                    </Grid2>
                                </Grid2> */}
                        </>
                    }



                    {
                        digiManualUplaod &&
                        <>
                           
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                                width: '100%',
                                marginBottom: '10px',
                                marginTop: '10px',
                            }}>
                               
                                {
                                    !digiBackButton && <>
                                <Box sx={{
                                    position: 'absolute',
                                    left: 0,

                                    '@media (min-width: 1000px)': {
                                        display: 'none' // Explicitly hide above 1000px
                                    }
                                }}>
                                    <IconButton
                                        onClick={() => navigate('/step-2')} // Or your custom back handler
                                        sx={{
                                            color: '#000', // Customize color
                                            padding: '16px'
                                        }}
                                    >
                                        <ArrowBack />
                                    </IconButton>
                                </Box>
                                </>
                               }
                                
                                <img
                                    src={source == "cosmos" ? collab : navLogo}
                                    alt="Logo"
                                    style={{
                                        // Adjust margin to account for arrow on mobile
                                        marginLeft: { xs: '40px', md: 0 }
                                    }}
                                    className={source == "cosmos" ? DigilockerStyles.twologo : DigilockerStyles.nav_logo}
                                />
                            </Box>
                        
                            
                            < Typography className={DigilockerStyles.upload_title}>
                                Upload Documents
                            </Typography>

                            {
                                digiError && <Typography
                                    // sx={{color:"#000000"}}
                                    className={DigilockerStyles.validation_error}
                                >
                                    {digiError}

                                    {/* You have denied consent to access your Aadhaar details via DigiLocker. Provide your consent, to proceed with KYC. */}
                                </Typography>
                            }

                            <Typography className={DigilockerStyles.aadhar_title}
                                sx={{
                                    padding: "20px 10px 0px 10px"
                                }}
                            >
                                Copy of valid Aadhaar card front side
                            </Typography>
                            <Typography className={DigilockerStyles.aadhar_subtitle}>Provide below documents in JPG or PNG form.</Typography>

                            <Box sx={{ marginTop: "7px", position: "relative" }}>
                              

                                <FileUploader
                                    multiple={false}
                                    maxSize={"1mb"}
                                    hoverTitle="rAI"
                                    label="Upload or drop a file right here"
                                    name="file1"
                                    handleChange={(file) => {
                                        if (aadhaarFileUploader) handlePicFile(file, "aadharFront");
                                    }}
                                    disabled={!aadhaarFileUploader}
                                >
                                    <Box
                                        className={DigilockerStyles.fileuploader}
                                        sx={{

                                            border: aadhaarFileUploader
                                                ? "2px dashed #aaa"
                                                : "2px dashed #ccc",
                                            borderRadius: "10px",
                                            cursor: aadhaarFileUploader ? "pointer" : "not-allowed",
                                            backgroundColor: aadhaarFileUploader
                                                ? "transparent"
                                                : "#f5f5f5",
                                        }}
                                    >
                                        <Typography
                                            className={DigilockerStyles.fileuploader_txt}
                                            color={aadhaarFileUploader ? "text.primary" : "text.disabled"}
                                        >
                                            {aadhaarFileUploader
                                                ? "Drag and Drop here / "
                                                : "Uploader Disabled"}
                                            {aadhaarFileUploader && (
                                                <span
                                                    className={DigilockerStyles.fileuploader_txt1}

                                                >
                                                    Browse File
                                                </span>
                                            )}
                                        </Typography>
                                    </Box>
                                </FileUploader>


                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        position: "absolute",
                                        bottom: "-20px", // Adjust based on spacing requirements
                                        right: "0px", // Align to the right of the parent container
                                    }}
                                >
                                    <img
                                        src={lock}
                                        alt="locker"
                                        style={{
                                            width: "10px",
                                            height: "12.5px",
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            fontFamily: "Inter400",
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            letterSpacing: "0px",
                                            color: "#7A7C7F",
                                            padding: "0px 0px 0px 5px",
                                        }}
                                    >
                                        Secure
                                    </Typography>
                                </Box>
                            </Box>

                            <Grid2 style={{ display: "flex", flexDirection: "row" }}>
                                {aadharFrontFileName && (
                                    <Typography
                                        style={{
                                            marginTop: "10px ",
                                            fontSize: "15px",
                                            fontFamily: "Inter400 !important",
                                            color: "#000000",
                                        }}
                                    >
                                        {aadharFrontFileName}
                                    </Typography>
                                )}
                                {
                                    aadhaarFrontVerify && <img src={verified} alt="logo" style={{
                                        marginTop: "12px", paddingLeft: "10px"
                                    }} />
                                }
                            </Grid2>
                            {aadharFrontError && (
                                <Typography
                                    className={DigilockerStyles.validation_error}
                                >
                                    {aadharFrontError}
                                </Typography>
                            )}

                            <Typography className={DigilockerStyles.aadhar_title}
                                sx={{
                                    padding: (aadharFrontFileName || aadharFrontError) ? "10px 10px 0px 10px" : "30px 10px 0px 10px"
                                }}>
                                Copy of valid Aadhaar card back side
                            </Typography>
                            <Typography className={DigilockerStyles.aadhar_subtitle}>Provide below documents in JPG or PNG form.</Typography>

                            <Box sx={{ marginTop: "7px", position: "relative" }}>



                                <FileUploader
                                    multiple={false}
                                    maxSize={"1mb"}
                                    hoverTitle="rAI"
                                    label="Upload or drop a file right here"
                                    name="file1"
                                    handleChange={(file) => {
                                        if (aadhaarFileUploader) handlePicFile(file, "aadharBack");
                                    }}
                                    disabled={!aadhaarFileUploader}
                                >
                                    <Box
                                        className={DigilockerStyles.fileuploader}
                                        sx={{

                                            border: aadhaarFileUploader
                                                ? "2px dashed #aaa"
                                                : "2px dashed #ccc",
                                            borderRadius: "10px",
                                            cursor: aadhaarFileUploader ? "pointer" : "not-allowed",
                                            backgroundColor: aadhaarFileUploader
                                                ? "transparent"
                                                : "#f5f5f5",
                                        }}
                                    >
                                        <Typography
                                            className={DigilockerStyles.fileuploader_txt}
                                            color={aadhaarFileUploader ? "text.primary" : "text.disabled"}
                                        >
                                            {aadhaarFileUploader
                                                ? "Drag and Drop here / "
                                                : "Uploader Disabled"}
                                            {aadhaarFileUploader && (
                                                <span
                                                    className={DigilockerStyles.fileuploader_txt1}

                                                >
                                                    Browse File
                                                </span>
                                            )}
                                        </Typography>
                                    </Box>
                                </FileUploader>


                                <Box

                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        position: "absolute",
                                        bottom: "-20px", // Adjust based on spacing requirements
                                        right: "0px", // Align to the right of the parent container
                                    }}
                                >
                                    <img
                                        src={lock}
                                        alt="locker"
                                        style={{
                                            width: "10px",
                                            height: "12.5px",
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            fontFamily: "Inter400",
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            letterSpacing: "0px",
                                            color: "#7A7C7F",
                                            padding: "0px 0px 0px 5px",
                                        }}
                                    >
                                        Secure
                                    </Typography>
                                </Box>
                            </Box>


                            <Grid2 style={{ display: "flex", flexDirection: "row" }}>
                                {aadharBackFileName && (
                                    <Typography
                                        style={{
                                            marginTop: "10px ",
                                            fontSize: "15px",
                                            fontFamily: "Inter400 !important",
                                            color: "#000000",
                                        }}
                                    >
                                        {aadharBackFileName}
                                    </Typography>
                                )}
                                {
                                    aadhaarBackVerify && <img src={verified} alt="logo" style={{
                                        marginTop: "12px", paddingLeft: "10px"
                                    }} />
                                }
                            </Grid2>

                            {aadharBackError && (
                                <Typography
                                    className={DigilockerStyles.validation_error}
                                >
                                    {aadharBackError}
                                </Typography>
                            )}




                            <Typography className={DigilockerStyles.pan_title}
                                sx={{
                                    paddingTop: aadharBackFileName || aadharBackError ? "10px" : "40px"
                                }}>
                                Manual Pan Upload
                            </Typography>
                            <Typography className={DigilockerStyles.pan_subtitle}>Provide below documents in JPG or PNG form.</Typography>

                            <Box sx={{ marginTop: "7px", position: "relative" }}>
                                

                                <FileUploader
                                    multiple={false}
                                    maxSize={"1mb"}
                                    hoverTitle="rAI"
                                    label="Upload or drop a file right here"
                                    name="file1"
                                    handleChange={(file) => {
                                        if (panFileUploader) handlePicFile(file, "pan");
                                    }}
                                    disabled={!panFileUploader}
                                >
                                    <Box
                                        className={DigilockerStyles.fileuploader}
                                        sx={{

                                            border: panFileUploader
                                                ? "2px dashed #aaa"
                                                : "2px dashed #ccc",

                                            cursor: panFileUploader ? "pointer" : "not-allowed",
                                            backgroundColor: panFileUploader
                                                ? "transparent"
                                                : "#f5f5f5",
                                        }}
                                    >
                                        <Typography
                                            className={DigilockerStyles.fileuploader_txt}
                                            color={panFileUploader ? "text.primary" : "text.disabled"}
                                        >
                                            {panFileUploader
                                                ? "Drag and Drop here / "
                                                : "Uploader Disabled"}
                                            {panFileUploader && (
                                                <span
                                                    className={DigilockerStyles.fileuploader_txt1}
                                                >
                                                    Browse File
                                                </span>
                                            )}
                                        </Typography>
                                    </Box>
                                </FileUploader>

                              
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        position: "absolute",
                                        bottom: "-20px", // Adjust based on spacing requirements
                                        right: "0px", // Align to the right of the parent container
                                    }}
                                >
                                    <img
                                        src={lock}
                                        alt="locker"
                                        style={{
                                            width: "10px",
                                            height: "12.5px",
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            fontFamily: "Inter400",
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            letterSpacing: "0px",
                                            color: "#7A7C7F",
                                            padding: "0px 0px 0px 5px",
                                        }}
                                    >
                                        Secure
                                    </Typography>
                                </Box>


                            </Box>
                            <Grid2 style={{ display: "flex", flexDirection: "row" }}>
                                {panFileName && (
                                    <Typography
                                        style={{
                                            marginTop: "20px ",
                                            fontSize: "15px",
                                            fontFamily: "Inter400 !important",
                                            color: "#000000",
                                        }}
                                    >
                                        {panFileName}
                                    </Typography>
                                )}
                                {
                                    panVerify && <img src={verified} alt="logo" style={{
                                        marginTop: "20px", paddingLeft: "10px",width:"30px",height:"22px"
                                    }} />
                                }
                            </Grid2>
                            {panError && (
                                <Typography
                                    className={DigilockerStyles.validation_error}
                                >
                                    {panError}
                                </Typography>
                            )}


                            <Grid2 className={DigilockerStyles.but_card}
                            sx={{
                                paddingTop:aadharBackError || panError ?"21px":"41px"
                            }}>

                                {/* {
                                    digiBackButton && <>
                                        <Grid2 item xs={12} sm={6}>
                                            <Button
                                                className={DigilockerStyles.back_button}
                                                variant="outlined"
                                                onClick={handleManualToDigiPage}
                                            >
                                                Back
                                            </Button>
                                        </Grid2>
                                    </>
                                } */}


                                <Grid2>
                                    <Button
                                        className={DigilockerStyles.manual_uploadbtn}
                                        sx={{
                                            backgroundColor: enable ? '#f3d45e' : '#C4C4C4',

                                        }}

                                        onClick={enable ? handleBothAbsentUpload : null}

                                    >
                                        {loading ? 'Verifying...' : 'Continue'}
                                    </Button>
                                </Grid2>
                            </Grid2>

                            {/* <Typography className={DigilockerStyles.hyperLink}
                                onClick={()=>{dispatch(setDigiManualUploadStatusToFalse() )}
                            }
                            >
                                   Back to DigiLocker
                            </Typography> */}


                        </>
                    }









                    <Box className={DigilockerStyles.card}>
                        <img
                            src={icon} // Replace with your image URL
                            alt="Checkmark"
                            className={DigilockerStyles.icon}
                        />
                        <Typography className={DigilockerStyles.txt}>
                            Your account details are safe & secure with us.
                        </Typography>
                    </Box>

                </Box>



                <Modal sx={{ border: "none" }} open={crop.modal} onClose={handleCropCancel} disableAutoFocus disableEnforceFocus>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: { xs: "90vw", sm: "80vw", md: "65vw" },
                            height: { xs: "80vh", sm: "80vh", md: "70vh" },
                            backgroundColor: "#ffffff",
                            borderRadius: "12px",
                            display: "flex",
                            flexDirection: "column",
                            padding: "15px !important",
                            // overflow: 'hidden',
                        }}
                    >
                        {/* Cropper container */}
                        <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
                            <Cropper
                                ref={cropperRef}
                                src={crop.image}
                                rotateImage={true}
                                transformImage={true}
                                imageRestriction={ImageRestriction.none} //If ever required to make the image move freely
                                // imageRestriction={ImageRestriction.fitArea}  //If ever required to make the imagefit
                                stencilProps={{
                                    movable: true,
                                    resizable: true,
                                }}
                                defaultSize={defaultSize} //dev-trupti on 03-07-2025 To make the cropper take the full hiehgt and width of the image
                                wheelZoomRatio={0.1}
                                style={{ height: "100%", width: "100%", objectFit: "contain" }} // Ensure Cropper takes full space
                            />
                        </Box>

                        {/* Button controls */}
                        <Box
                            sx={{
                                pt: 2,
                                display: "flex",
                                justifyContent: "space-between",
                                gap: 2,
                                borderTop: "1px solid #eee",
                                flexShrink: 0,
                            }}
                        >
                            <Box>
                                <Button className={DigilockerStyles.cropButton} onClick={handleCropCancel}>Cancel</Button>
                            </Box>
                            <Box>
                                <IconButton onClick={rotateLeft} aria-label="Rotate Left">
                                    <RotateLeftIcon className={DigilockerStyles.rotateIcon} />
                                </IconButton>

                                <IconButton onClick={rotateRight} aria-label="Rotate Right">
                                    <RotateRightIcon className={DigilockerStyles.rotateIcon} />
                                </IconButton>
                            </Box>
                            <Box>
                                <Button className={DigilockerStyles.cropButton} onClick={handleSubmit}>Submit</Button>
                            </Box>
                        </Box>
                    </Box>
                </Modal>

               {/* <Snackbar
                    open={snackbar.open}
                    autoHideDuration={5000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    sx={{
                        "& .MuiSnackbar-root": {
                            top: 34,
                            right: 24,
                        }
                    }}
                >
                    <Alert
                        onClose={handleCloseSnackbar}
                        severity={snackbar.severity}
                        sx={{ width: '100%' }}
                    >
                        {snackbar.message}
                    </Alert>
                </Snackbar>

                */}

            </Box>
       }
        </main>
    )
}